export const accountTypeOptions = [
    { value: 'admin', label: '管理代表者' },
    { value: 'sub-admin', label: '管理許可子' },
    { value: 'member', label: '管理子' },
    { value: 'single', label: '単独' },
    { value: 'personal', label: 'パーソナルユーザー' },
];

export const industryOptions = [
    { value: '01', label: '建設業' },
    { value: '02', label: '卸売業，小売業' },
    { value: '03', label: '製造業' },
    { value: '04', label: '不動産業，物品賃貸業' },
    { value: '05', label: '医療，福祉' },
    { value: '06', label: '学術研究，専門・技術サービス業​' },
    { value: '07', label: '運輸業，郵便業​' },
    { value: '08', label: '情報通信業' },
    { value: '09', label: '宿泊業，飲食サービス業' },
    { value: '10', label: '生活関連サービス業，娯楽業' },
    { value: '11', label: '農業，林業​' },
    { value: '12', label: '金融業，保険業​' },
    { value: '13', label: '教育，学習支援業' },
    { value: '14', label: '電気・ガス・熱供給・水道業' },
    { value: '15', label: '漁業' },
    { value: '16', label: '鉱業，採石業，砂利採取業​' },
    { value: '99', label: 'その他業種' },
    { value: '00', label: '設定なし' },
    { value: '', label: 'NULL' },
];

export const employeeCountOptions = [
    { value: '01', label: '1~10人以下' },
    { value: '02', label: '11~300人以下' },
    { value: '03', label: '301~2000人未満' },
    { value: '04', label: '2000人以上' },
    { value: '', label: 'NULL' },
];
